import {PureComponent} from 'preact-compat'
import {h, ComponentChild} from 'preact'
import {isChangeEvent, isInputClickEvent} from '../../libs/preact-entry'

export const createRandomString = (length: number) => {
  let str = ''
  while (str.length < length) {
    str += Math.random().toString(36).substr(2)
  }
  return str
}

interface Props {
  maxlength?: number,
  title?: ComponentChild,
  meta?: string,
  qaClasses?: string,
  error?: string,
  type?: string,
  value?: string | number | Array<string>,
  checked?: boolean | string,
  name?: string,
  min?: number,
  max?: number
  id?: string,
  onChange?: (e: ChangeEvent) => void,
  onChangeCallback?: (e: ChangeEvent) => void,
  onChangeCheckbox?: (e: ClickEvent<HTMLInputElement>) => void,
  required?: boolean,
  readOnly?: boolean | string,
  placeholder?: string,
  disabled?: boolean,
  pattern?: string,
}

class InputGroup extends PureComponent<Props> {
  randomId: string

  constructor(props: Props) {
    super()
    this.randomId = props.id || createRandomString(8)
  }

  render(props: Props) {
    const restriction = typeof props.maxlength !== 'undefined' ?
      <span className='restriction pull-right'>Max. {props.maxlength} characters</span>
        : null

    return <div className='form-group'>
      <label for={this.randomId}>{props.title}</label>
      {restriction}
      {props.meta ? <p>{props.meta}</p> : null}
      <input
        className={`form-control ${props.qaClasses || ''} ${props.error && props.error !== '' ? 'validation-error' : ''}`}
        type={props.type}
        id={this.randomId}
        value={props.value}
        checked={!!props.checked}
        name={props.name}
        min={props.min}
        max={props.max}
        onClick={e => {
          if (props.onChangeCheckbox && isInputClickEvent(e)) {
            props.onChangeCheckbox(e)
          }
        }}
        onChange={e => {
          if (props.onChange && isChangeEvent(e)) {
            props.onChange(e)
          }
          if (props.onChangeCallback && isChangeEvent(e)) {
            props.onChangeCallback(e)
          }
        }}
        required={props.required}
        disabled={props.disabled}
        readOnly={!!props.readOnly}
        maxLength={props.maxlength}
        placeholder={props.placeholder}
        pattern={props.pattern} />
      {props.error && props.error !== '' ? <div className='validation-error'>{props.error}</div> : null}
    </div>
  }
}

export default InputGroup
